import { authFetch } from "lib/api/authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";

export async function getReceivedOrganizationInvitations() {
  try {
    const response = await authFetch(
      `${BACKEND_URL}/organization/invitations/received`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    const data = await response.json().catch(() => ({}));
    return {
      success: response.ok && data?.success === true,
      message: data?.message ?? "",
      data: data?.data ?? null,
    };
  } catch (error) {
    console.error("[getReceivedOrganizationInvitations] failed:", error);
    return {
      success: false,
      message: "받은 조직 초대를 불러오지 못했습니다.",
      data: null,
    };
  }
}
